<div class="surface list-container" *ngIf="selectedEntity">
  
  <div class="table-scroll-area">
    <table class="cyber-table">
      <thead>
        <tr>
          <th *ngFor="let field of entityFields">{{ field.label }}</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let entity of paginatedEntities" (click)="selectEntity(entity)">
          <td *ngFor="let field of entityFields">
            {{ getFieldValue(field, entity) }}
          </td>
        </tr>
        <tr *ngIf="paginatedEntities.length === 0">
          <td [attr.colspan]="entityFields.length" style="text-align: center; color: #a0aec0;">
            No hay registros disponibles.
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <div class="pagination-controls">
    <button class="btn secondary" (click)="prevPage()" [disabled]="currentPage === 1">< Anterior</button>
    <span class="page-info">Pág {{ currentPage }} / {{ totalPages }}</span>
    
    <div class="page-size">
      <label>Mostrar:</label>
      <select class="form-control" (change)="changePageSize($event)">
        <option [value]="5">5</option>
        <option [value]="10">10</option>
        <option [value]="20">20</option>
      </select>
    </div>
    
    <button class="btn secondary" (click)="nextPage()" [disabled]="currentPage === totalPages">Siguiente ></button>
  </div>
</div>